import { merge } from '../../../helper';

// ----------------------------------------------------------------------------

function findOptions(
    element: HTMLSelectElement,
    find: any,
    config?: Record<string, any>,
): HTMLOptionElement | undefined {
    // Default Config
    const defConfig = {
        type: 'value', // 'value' or 'text'
    };

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    // Foreach Options
    for (const elOption of element.options) {
        if (elOption[defConfig.type] === find) {
            return elOption;
        }
    }
}

// ----------------------------------------------------------------------------

export default findOptions;
